import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithDate } from '../columns';

/**
 * Scheduled Routes list configuration
 * Shows routes with scheduled status
 */
export const scheduledTripsList: ListBuilderList = {
	id: 'scheduled-trips',
	name: 'Scheduled',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		routeStatus: {
			defaultValue: [{ id: 'scheduled', label: 'Scheduled' }],
		},
	},
	columns: createTripColumnsWithDate(),
	defaultSortId: 'date-asc',
	sortOrder: 2,
};
